import { Web3, utils } from 'web3';
import erc20Abi from './erc20abi.json';
import { TOKEN_SFL, TOKEN_TRI } from '../lib/name-space';
export default class Web3j {
  web3;
  sfl;
  tri;
  tokenContracts = {};

  constructor() {
    this.sfl = TOKEN_SFL;
    this.tri = TOKEN_TRI;

    // 환경 변수에서 Alchemy API URL 가져오기
    const network = `https://polygon-mainnet.g.alchemy.com/v2/${process.env.REACT_APP_ALCHEMY_URL}`; // tokens
    this.web3 = new Web3(new Web3.providers.HttpProvider(network));
    this.tokenContracts[this.sfl] = new this.web3.eth.Contract(erc20Abi, process.env.REACT_APP_SFL_CONTRACT_ADDRESS);
    this.tokenContracts[this.tri] = new this.web3.eth.Contract(erc20Abi, process.env.REACT_APP_TRI_CONTRACT_ADDRESS);
  }

  async getTokenBalance(aWalletAddr, symbol) {
    try {
      // 잔액 조회 (wei 단위)
      const balance = await this.tokenContracts[symbol].methods.balanceOf(aWalletAddr).call();
      return this.weiToEth(balance);
      // const obj = {
      //   address: aWalletAddr,
      //   symbol,
      //   balance: packBigNumbers(this.weiToEth(balance)),
      // };
      // return obj;
    } catch (error) {
      console.error('Error fetching token balance:', error);
      return 'Error';
    }
  }

  weiToEth(aAmount) {
    return utils.fromWei(aAmount, 'ether');
  }
}
